export const ROUTES = {
  HOME: '/home',
  DETAILS: '/details',
  CONTACTS: '/contacts',
  CREATEFORMPAGE: '/createFormPage',
  PRICES: '/pricesPage',
};
